module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ep"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("I was surprised that someone would devote a life to such things, to faking things and not quite succeeding at it, and when one succeeds one only adds one ephemera to another, what one can’t have to what one doesn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("Pierre Michon, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Masters and Servants")])]), _vm._v(" "), _c('p', {
    staticClass: "half-space"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("Why do I no longer dream about my mother? Perhaps because I have written too much about her, even distributing her beautiful profile on the cover of a book. Without meaning to exorcize anything, I exorcized her presence. My mother wasn’t bothering me, I summoned her up myself by writing so much about her, but I suspect that in the end I created a literary character – complex, artistic, complicated – and lost the real mother, the dead mother, as a result. I am the orphan of a dead mother because I wrote too much about her.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("Francisco Umbral, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("A Creature of Distance")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0